import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { useGeneralStore } from "%/stores/general-store";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useDraftPublicationFeedStore = defineSmartFeedPiniaStore("draft-publication-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    metadata: {
      publicationOrgId: useGeneralStore().orgId,
    },
  }),
  getters: {
    feedUrl() {
      return `/publication/org/${this.metadata.publicationOrgId}/smart-feed/status`;
    },
    smartFeedRequestGetParams() {
      return {
        last_id: this.metadata.lastId,
        status: "draft",
      };
    },
  },
});
